export default __webpack_public_path__ + "static/media/billing-gray.b02d5e3a.svg";